import { createSelector } from '@ngrx/store';
import { AppState } from '../app.state';

export const selectLoadingState = (state: AppState) => state.isLoading;

export const selectIsLoading = createSelector(
  selectLoadingState,
  (isLoading) => isLoading
);
